// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"b189a11b","130":"4e111c73","237":"57d87d6e","264":"52e088c7","428":"bf456be5","453":"e96cd896","638":"92a15925","713":"b2c23c3b","834":"e99254fc","989":"fd0d87e0"}[chunkId] + ".chunk.js";
};